import { motion } from 'framer-motion';
import type { Citation } from '../../../services/api';

/**
 * Aparato de notas / fuentes — presentación tipo notas al pie de un manuscrito,
 * no tarjetas. Los estilos (.refs-block, .ref-note, etc.) viven en
 * SharedContentStyles.
 *
 * `citation.page` llega en base 0 (página física del PDF); se muestra `page + 1`
 * para coincidir con las etiquetas `[fichero, pág N]` del texto de la respuesta.
 */
export default function CitationsBlock({ citations }: { citations: Citation[] }) {
  if (!citations || citations.length === 0) return null;

  return (
    <div className="refs-block">
      <p className="refs-label">Fuentes</p>
      <motion.ol
        className="refs-list"
        initial="hidden"
        animate="show"
        variants={{ show: { transition: { staggerChildren: 0.07 } } }}
      >
        {citations.map((citation, index) => (
          <motion.li
            key={`${citation.chunk_id}-${index}`}
            className="ref-note"
            variants={{ hidden: { opacity: 0, y: 6 }, show: { opacity: 1, y: 0 } }}
            transition={{ type: 'spring', stiffness: 200, damping: 24 }}
          >
            <span className="ref-index">{index + 1}</span>
            <div className="ref-body">
              <span className="ref-source">{citation.source}</span>
              {(citation.page != null || citation.section) && (
                <span className="ref-loc">
                  {citation.page != null ? `p. ${citation.page + 1}` : ''}
                  {citation.page != null && citation.section ? ' · ' : ''}
                  {citation.section ? `§ ${citation.section}` : ''}
                </span>
              )}
              {citation.quote && <p className="ref-quote">{citation.quote}</p>}
            </div>
          </motion.li>
        ))}
      </motion.ol>
    </div>
  );
}
